import { navigate } from 'gatsby';

import ArrowLeft from '../../images/icon-arrow-left.svg';

type PageTitleProps = {
  link?: string;
  title: string;
};

export const BackNavigation = ({ link, title }: PageTitleProps) => (
  <header className={'back-navigation'}>
    <button
      onClick={() => {
        // @ts-ignore
        return navigate(link || -1);
      }}
    >
      <ArrowLeft />
    </button>
    <h1>{title}</h1>
  </header>
);
